import { Localizer } from '../../../locale/useTextLocalizer';
import { isNullish } from '@sas/nova-core/typeguards';
import { TablePosition } from '../../Table';
import { TreeTableProps } from '../types';

export const makeSayCell = (
  localize: Localizer,
  selectionMode: TreeTableProps['selectionMode'],
  getDataNode: TreeTableProps['getDataNode'],
  expandedNodes: ReadonlySet<string>,
  getRowAttributes?: TreeTableProps['getRowAttributes'],
  getRowKey?: TreeTableProps['getRowKey'],
  hideSelectionControlColumn?: TreeTableProps['hideSelectionControlColumn']
) => {
  return (params: {
    current: TablePosition;
    previous: TablePosition | undefined;
    default: string | null;
  }) => {
    const { current, previous } = params;
    const hasRowSelectionHeader =
      hideSelectionControlColumn !== true &&
      (selectionMode === 'parentChild' || selectionMode === 'multiple');
    const isInFirstDataColumn = current.colIndex === (hasRowSelectionHeader ? 1 : 0); // TODO: need to account for selection mode
    const hasRowChanged = current.rowIndex !== previous?.rowIndex;

    let level;
    let node;
    let hasLevelChanged = false;
    if (getDataNode) {
      // determine row level
      node = getDataNode(current.rowIndex);
      level = node?.level !== undefined ? node.level + 1 : undefined;

      const prevNode = previous ? getDataNode(previous.rowIndex) : undefined;
      hasLevelChanged = prevNode?.level !== node?.level;
    }

    const announceLevel = hasRowChanged && hasLevelChanged;
    const strings = [];

    if (announceLevel && !isNullish(level)) {
      strings.push(localize('level.msg', { level: String(level) }));
    }

    strings.push(params.default);

    if (isInFirstDataColumn) {
      // do TreeTable thing
      if (node) {
        const isParent = node?.hasChildren;
        const isExpanded = expandedNodes.has(node.id);

        if (isParent) {
          if (isExpanded) {
            strings.push(localize('expanded.msg'));
          } else {
            strings.push(localize('collapsed.msg'));
          }
        }
      }
    }

    if (getRowAttributes && getRowKey && hasRowChanged) {
      const rowKey = getRowKey(current.rowIndex);
      const rowAttributes = getRowAttributes(rowKey);

      strings.push(
        localize('position.setSize.msg', {
          position: rowAttributes.positionInSet,
          setSize: rowAttributes.setSize,
        })
      );
    }

    return strings.join(', ');
  };
};
